module.exports = __webpack_public_path__ + "img/logo_dataport.51905710.png";